import { UserEntity } from "@backstage/catalog-model";

const _UserCache: Map<string, Promise<UserEntity | null>> = new Map();

export const clearUserCache = () => {
    _UserCache.clear();
};

export const getCachedUser = (ref: string, userFactory: (userRef: string) => Promise<UserEntity | null>): Promise<UserEntity | null | undefined> => {
    if (!_UserCache.has(ref)) {
        _UserCache.set(ref, userFactory(ref));
    }
    return _UserCache.get(ref) ?? Promise.resolve(null);
};